module.exports = __webpack_public_path__ + "static/media/hof-first-prize-theprint.54bf46d3.jpeg";